import Settings from "./settings";
import Storage from "./storage.service";

var Tracking = {};

// var unlimited_text = "UNLIMITED";

Tracking.initObj = () => {
	let init_obj = {
		breadcrumbs: ["Home"],
		language: "en-US",
		http_code: "200",
		customer_status: "not logged in",
		uid: "",
		Unique_User_ID_session: "",
		Unique_User_ID_user: "",
	}
	window.dataLayer = [init_obj];
};

Tracking.init = function() {
	window.dataLayer = 
	[
		{
			breadcrumbs: ["Home"],
			language: "en-US",
			http_code: "200",
			customer_status: "not logged in",
			uid: "",
			Unique_User_ID_session: "",
			Unique_User_ID_user: "",
		},
	];

	// Google Tag Manager
	(function(w, d, s, l, i) {
		w[l] = w[l] || [];
		w[l].push({
			"gtm.start": new Date().getTime(),
			event: "gtm.js",
		});
		var f = d.getElementsByTagName(s)[0],
		j = d.createElement(s),
		dl = l !== "dataLayer" ? "&l=" + l : "";
		j.async = true;
		j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
		j.onload = () => {
			
		};
		f.parentNode.insertBefore(j, f);
	})(window, document, "script", "dataLayer", Settings.gtm_container_id);
	// End Google Tag Manager
	// GTMService.onload();
};

Tracking.event = function(
	event,
	eventCategory,
	eventAction,
	eventLabel = "",
	eventValue = ""
) {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		eventCategory: eventCategory,
		eventAction: eventAction,
		eventLabel: eventLabel ? eventLabel : "",
		eventValue: eventValue ? eventValue : "",
	};

	window.dataLayer.push(obj);

};

Tracking.event_with_callback = (
	event,
	eventCategory,
	eventAction,
	eventLabel = "",
	eventValue = "",
	callback
) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		eventCategory: eventCategory,
		eventAction: eventAction,
		eventLabel: eventLabel ? eventLabel : "",
		eventValue: eventValue ? eventValue : "",
		eventCallback : function() {
			callback()
		},
		eventTimeout : 3000
	};

	window.dataLayer.push(obj);

};

// Tracking.pixel_event = (event, plan_selection_1, plan_selection_2, value) => {
// 	window.dataLayer = window.dataLayer || [];
// 	let obj = {
// 		event: event,
// 		plan_selection_l1: plan_selection_1,
// 		plan_selection_l2: plan_selection_2,
// 		value: value ? value : "",
// 	};
// 	window.dataLayer.push(obj);

// }

Tracking.pixel_purchase_event = (event, plan_selection_1, plan_selection_2, value, transaction_id) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		plan_selection_l1: plan_selection_1,
		plan_selection_l2: plan_selection_2,
		value: value ? value : "",
		transaction_id: transaction_id ? transaction_id : null
	};
	// log("pushed event:", obj);
	window.dataLayer.push(obj);
}

Tracking.impression = (impressionVal) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		ecommerce: {
			detail: {
				//actionField: {}
				products: [impressionVal]
			}
		}
	});
};

Tracking.dimension = (dimension, dimensionVal) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {};
	obj[dimension] = dimensionVal;
	window.dataLayer.push(obj);
};

Tracking.metric = (metric, metricVal) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {};
	obj[metric] = metricVal;
	window.dataLayer.push(obj);
};

Tracking.ecommerce = (
	transactionId,
	transactionTotal,
	SKU,
	name,
	impressions = null
) => {
	window.dataLayer = window.dataLayer || [];

	let obj = {
		transactionId: transactionId,
		transactionTotal: transactionTotal,
		//impressions: impressions,
		transactionProducts: [
		{
			sku: SKU,
			name: name,
			category: "1",
			price: transactionTotal,
			quantity: 1
		}
		]
	};

	window.dataLayer.push(obj);
};

Tracking.page_view_event = function (obj) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(lowercaseStringsInObject(obj));
};

Tracking.custom_event = function(
	eventName,
	eventCustomName,
	extra_obj
) {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: eventName,
		custom_event_name: eventCustomName,
		journey_name: "mobile plan",   
		...extra_obj, 
	};

	// if ('cta_name' in obj) {
	// 	obj['cta_name'] = obj['cta_name'].toLowerCase();
	// }
	window.dataLayer.push(lowercaseStringsInObject(obj));

};

Tracking.GA4Ecommerce = (
	data,
	voice,
	intl_min,
	planName,
	planPrice,
	couponCode,
	customCombo,
	planDuration,
	subJourneyName,
	planSubCategory,
	customEventName,
	planDiscountPrice,
	itemIndex = 1
) => {
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer = window.dataLayer || [];
	if (customCombo) customCombo = customCombo.toLowerCase(); 
	let obj = {
		event: "eventTracker",
		custom_event_name: customEventName,
		journey_name: "mobile plan", //journey name
		sub_journey_name: subJourneyName, //sub journey name
		ecommerce: {
			items: [{
				item_id: customCombo, //id of the plan
				item_name: customCombo,
				item_brand: "virgin mobile uae", //brand of the product
				index: itemIndex, //plan position in the list
				discount: Number(planDiscountPrice), //discounted amount
				coupon: couponCode, //coupon code
				item_category: "mobile plan", //plan category
				item_category2: planSubCategory, //plan subcategory
				item_category3: `data: ${data} gb|local: ${voice} min|intl: ${intl_min} min`, //plan details (data, local, intl)
				item_category4: planDuration, //plan tenure "12 months",(always in month)
				item_list_name: "",
				item_list_id: "",
				price: planPrice, //original price
				quantity: 1 //quantity
			}]
		}
	};
	window.dataLayer.push(lowercaseStringsInObject(obj));
	Storage.set("eCommerceObj", JSON.stringify(obj), true);
}

const updateAndAppendAttributes = (existingObject, newAttributes) => {
	const updatedObject = { ...existingObject, ...newAttributes };
	return updatedObject;
}

Tracking.GA4EcommerceWithExtraParams = (newAttributes) => {
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer = window.dataLayer || [];
	let newObject = updateAndAppendAttributes(
		JSON.parse(Storage.get("eCommerceObj", true)), newAttributes
	);
	window.dataLayer.push(lowercaseStringsInObject(newObject));
	Storage.set("eCommerceObj", JSON.stringify(newObject), true);
}

Tracking.GA4EcommerceWithList = (customEventName, subJourneyName, plansList) => {
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: "eventTracker",
		journey_name: "mobile plan",
		sub_journey_name: subJourneyName,
		custom_event_name: customEventName,
		ecommerce: {
			items: plansList
		}
	}
	window.dataLayer.push(lowercaseStringsInObject(obj));
	Storage.set("eCommerceObj", JSON.stringify(obj), true);
}
Tracking.activeABTest = function (obj) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(obj);
};


// lowercase strings in onject values recursively:
const lowercaseStringsInObject = (obj) => {
	for (const key in obj){
		if (key === "event") continue;
		if (typeof obj[key] === 'object'){
			obj[key] = lowercaseStringsInObject(obj[key]);
		}else{
			if (typeof obj[key] === 'string'){
				obj[key]= obj[key].toLowerCase();
			}
		}
	}
	return obj;
}
export default Tracking;
